import React, { useEffect, useState } from 'react'

import { useHistory } from 'react-router-dom'

import {
  message, Button, Row, Col, Table, Spin, Upload, PageHeader, Divider, Tooltip, Pagination,
} from 'antd'
import {
  FileExcelOutlined, UploadOutlined, EditOutlined, AuditOutlined, CommentOutlined, EyeOutlined,
  ToolOutlined,
} from '@ant-design/icons'

import { format } from 'date-fns'
import Cookies from 'js-cookie'

import { useRecoilState } from 'recoil'

import { fetch, fetchDownload } from '../../utils/fetch'

import OrderStatus from '../component/OrderStatus'
import OrderTypeTag from '../component/OrderType'

import OrderFilter from '../component/OrderFilter'

import { userState } from '../../store'

import ParametricTypeModal from './component/ParametricTypeModal'

const { Column } = Table

const endpoint = process.env[`REACT_APP_ENDPOINT_${process.env.REACT_APP_ENV}`]

// eslint-disable-next-line react/prop-types
const Order = ({ name }) => {
  const history = useHistory()

  const [orderList, setOrderList] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [visible, setVisible] = useState(false)
  const [orderId, setOrderId] = useState('')
  const [current, setCurrent] = useState(1)
  const [limit, setLimit] = useState(10)
  const [count, setCount] = useState(0)
  const [query, setQuery] = useState()
  const [user, setUser] = useRecoilState(userState)
  const [dataExcel, setDataExcel] = useState({})
  // const [user] = useRecoilState(userState)

  const getDataOrder = (queryIn) => {
    setIsLoading(true)
    fetch({
      url: '/order',
      query: queryIn,
    }).then((res) => {
      if (res.data?.success) {
        console.log(res.data?.data.length)
        setOrderList(res.data?.data)
        setCount(res.data?.count)
      } else {
        message.error(res.message)
      }
      setIsLoading(false)
    })
  }

  const downloadExcel = (query) => {
    setIsLoading(true)
    fetchDownload({
      url: '/order/excel',
      fileName: `order_report_${format(new Date(), 'dd-MM-yyyy')}.xlsx`,
      query,
    }).then((res) => {
      if (res.success) {
        message.success('Download Excel Success')
      } else {
        message.error(res.message)
      }
    })
    setIsLoading(false)
    console.log(query)
  }

  useEffect(
    () => {
      getDataOrder({ current, limit })
    },
    [],
  )

  const onSuccess = async (parametricType) => {
    console.log('parametricType', parametricType)
    await setVisible(false)
    history.push(`/order/${orderId}/${parametricType}`)
  }

  const onCancel = () => {
    setVisible(false)
  }

  const props = {
    name: 'attachment',
    action: `${endpoint}/order`,
    // method: 'POST',
    accept: '.xml,.html,.htm',
    headers: {
      authorization: Cookies.get(`oms-token-${process.env.REACT_APP_ENV}`),
    },
    onChange(info) {
      setIsLoading(true)
      if (info.file.status !== 'uploading') {
        console.log(info.file, info.fileList)
        setIsLoading(false)
      }
      if (info.file.status === 'done') {
        message.success(`${info.file.name} file uploaded successfully`)
        getDataOrder({ ...query, current, limit })
        setIsLoading(false)
      } else if (info.file.status === 'error') {
        message.error(`${info.file.name} file upload failed.`)
        setIsLoading(false)
      }
    },
    showUploadList: false,
  }

  const onSearch = (queryIn) => {
    setQuery(queryIn)
    getDataOrder({ ...queryIn, current, limit })
  }

  // const getData = (currentPage, pageSize) => {
  //   console.log(currentPage, pageSize)
  //   return orderList.slice((currentPage - 1) * pageSize, currentPage * pageSize)
  // }

  const onShowSizeChange = (currentPage, pageSize) => {
    console.log(current, pageSize)
    setLimit(pageSize)
    getDataOrder({ ...query, current, limit: pageSize })
  }

  const onChangePage = (page) => {
    setCurrent(page)
    getDataOrder({ ...query, current: page, limit })
  }

  // eslint-disable-next-line react/prop-types
  const MyPagination = ({ total, onChange }) => (
    <Pagination
      showSizeChanger
      onChange={onChange}
      total={total}
      current={current}
      defaultPageSize={limit}
      // pageSizeOptions={[10, 20, 50]}
      onShowSizeChange={onShowSizeChange}
      style={{ float: 'right' }}

    />
  )

  return (
    <>
      <Spin spinning={isLoading} tip="Loading...">
        <PageHeader
          ghost={false}
          title={name}
          // subTitle={`ID : ${orderId}`}
          extra={(
            <Row gutter={[16]}>
              <Col>
                <Upload {...props}>
                  <Button icon={<UploadOutlined />} type="primary">Upload</Button>
                </Upload>
              </Col>
              {user.role.includes('ADMIN') && (
                <Col>
                  <Button icon={<FileExcelOutlined />} onClick={() => downloadExcel(dataExcel)}>Download Excel</Button>
                </Col>
              )}
            </Row>
          )}
        >
          <Row gutter={24}>
            <Col xs={24} md={24}>
              <OrderFilter onSearch={onSearch} />
            </Col>
          </Row>
          <Divider />
          {/* <React.Fragment> */}
          <Table dataSource={orderList} size="small" scroll={{ x: 1500 }} pagination={false}>
            <Column title="Order Id" dataIndex="orderId" key="orderId" width={150} align="center" sortDirections={['ascend']} sorter={(a, b) => a.orderId - b.orderId} />
            <Column title="Server Id" dataIndex="xmlServerId" key="xmlServerId" width={100} />
            <Column title="Xml No." dataIndex="xmlOrderNo" key="xmlOrderNo" width={100} />
            <Column title="Rev." dataIndex="xmlRev" key="xmlRev" width={100} />
            <Column title="Type" dataIndex="orderTypeDetail" key="orderTypeDetail" width={150} render={(text) => (<OrderTypeTag orderType={text?.orderTypeCode} orderTypeDescr={text?.orderTypeDescr} />)} />

            <Column
              title="Status"
              dataIndex="status"
              key="status"
              width={150}
              render={(text, row) => {
                const desc = row.statusDetail
                return (
                  <>
                    <OrderStatus
                      click
                      orderStatus={text}
                      orderId={row.orderId}
                      orderStatusDesc={desc?.statusDescr}
                    />
                    {row.supplement === true && <ToolOutlined style={{ marginRight: 8 }} />}
                  </>
                )
              }}
            />
            <Column title="Sold to" dataIndex="orderHeader" key="orderHeader" width={150} render={(text) => text?.soldTo || '-'} />
            <Column title="Designer" dataIndex="orderHeader" key="orderHeader" width={150} render={(text) => text?.designer || '-'} />
            <Column title="Sales employee" dataIndex="orderHeader" key="orderHeader" width={150} render={(text) => text?.salesEmp || '-'} />
            <Column
              title="Remaining"
              dataIndex="RemainingStatus"
              key="RemainingStatus"
              // align="center"
              width={200}
              render={(text, row) => {
                const descr = row.RemainingDate
                let color = '#000000'
                if (text === true) {
                  color = '#F5222D'
                } if (text === null) {
                  color = '#ffc53d'
                }
                if (descr) {
                  return (
                    <Tooltip
                      placement="top"
                      title={`Delv Date: 
                      ${format(new Date(row?.orderSoQueue?.delvDate.replace(/\./g, '-')), 'dd/MM/yyyy')}`}
                    >
                      <div style={{ color }}>
                        {descr || '-'}
                      </div>
                    </Tooltip>

                  )
                }
                return ('-')
              }}
            />
            <Column title="Created At" dataIndex="createdAt" key="createdAt" width={150} render={(text) => format(new Date(text), 'dd/MM/yyyy HH:mm')} />
            <Column title="Created By" dataIndex="createdBy" key="createdBy" width={150} render={(text) => text || '-'} />
            <Column
              title="Action"
              dataIndex="action"
              key="action"
              fixed="right"
              align="center"
              width={100}
              render={(text, row) => (
                <>
                  {row.status === 'DRF'
                    && (
                      <Tooltip title="Create SO">
                        <Button
                          shape="circle"
                          icon={<EditOutlined />}
                          onClick={() => history.push(`/order/create/${row.orderId}`)}
                        />
                      </Tooltip>
                    )}
                  {((row.status === 'PRC' || row.status === 'SOC' || row.status === 'ODI') && row.orderType === 'PAR')
                    && (
                      <Tooltip title="Submit Order">
                        <Button
                          shape="circle"
                          icon={<AuditOutlined />}
                          onClick={() => { history.push(`/order/submit/${row.orderId}`) }}
                        />
                      </Tooltip>
                    )}
                  {((row.status === 'PRC' || row.status === 'SOC') && row.orderType === 'DSB')
                    && (
                      <Tooltip title="View Detail">
                        <Button
                          shape="circle"
                          icon={<EyeOutlined />}
                          onClick={() => { history.push(`/order/complete/${row.orderId}`) }}
                        />
                      </Tooltip>
                    )}
                  {(row.status === 'ODS' || row.status === 'ODV')
                    && (
                      <Tooltip title="Review">
                        <Button
                          shape="circle"
                          icon={<CommentOutlined />}
                          onClick={() => { history.push(`/order/review/${row.orderId}`) }}
                        />
                      </Tooltip>
                    )}
                  {(!['DRF', 'SOC', 'PRC', 'ODI', 'ODS', 'ODV'].includes(row.status))
                    && (
                      <Tooltip title="View Detail">
                        <Button
                          shape="circle"
                          icon={<EyeOutlined />}
                          onClick={() => { history.push(`/order/complete/${row.orderId}`) }}
                        />
                      </Tooltip>
                    )}
                </>
              )}
            />
          </Table>
          <MyPagination
            total={count}
            // current={current}
            onChange={onChangePage}
          />
          {/* </React.Fragment> */}
        </PageHeader>
        <ParametricTypeModal
          visible={visible}
          onSuccess={onSuccess}
          onCancel={onCancel}
        />
      </Spin>
    </>

  )
}

export default Order
